import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServiceDeskNavigationResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { helpCenterSettingsWidgetConfigurationRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsWidgetConfigurationRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { HelpCenterSettingsWidgetConfigurationEntryPoint } from './ui/widget-configuration/index.tsx';
import { navigation } from './common/constants.tsx';

export const helpCenterSettingsWidgetConfigurationRouteEntry = createEntry(
	helpCenterSettingsWidgetConfigurationRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'customer-service.widget-configuration',
		layout: serviceProjectLayout,
		navigation,
		component: ErrorPagesNotFound,

		entryPoint: () => {
			if (!fg('csm_agent_config_widget_configuration_embed_page')) {
				return undefined;
			}
			return HelpCenterSettingsWidgetConfigurationEntryPoint;
		},

		resources: [...getServiceDeskNavigationResources()],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsWidgetConfigurationRouteEntry.tsx',
				whichExportToUse: 'helpCenterSettingsWidgetConfigurationRouteEntry',
			},

			enabled: true,
		},
	}),
);
